import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20hall%20with%20red%20velvet%20curtains%2C%20golden%20stage%20lights%2C%20dramatic%20spotlight%20effect%2C%20elegant%20movie%20palace%20interior%2C%20luxurious%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20no%20text%2C%20no%20people%2C%20pure%20architectural%20photography&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="草民影院 - 免费高清影视在线观看"
        title="草民影院 - 免费电影、免费电视剧、免费看大片"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <div className="animate-fade-in-up">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 font-serif tracking-wide">
            草民影院
          </h1>
          <p className="text-base md:text-xl text-white/80 mb-2 max-w-2xl mx-auto leading-relaxed">
            免费电影 · 免费电视剧 · 免费看大片 · 免费追剧
          </p>
          <p className="text-sm md:text-lg text-white/60 mb-8 max-w-2xl mx-auto">
            高清不卡在线观看，无需付费，畅享免费高清影视
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/category/movie"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/30"
            >
              <i className="ri-play-circle-line mr-2"></i>
              开始观影
            </Link>
            <Link
              to="/category/tv-series"
              className="px-8 py-3 rounded-full border-2 border-white/30 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-tv-line mr-2"></i>
              热门剧集
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="absolute bottom-10 md:bottom-14 left-0 right-0">
          <div className="flex items-center justify-center gap-8 md:gap-16">
            {[
              { num: '10000+', label: '影视资源' },
              { num: 'HD 1080P', label: '高清画质' },
              { num: '7x24h', label: '持续更新' },
              { num: '0元', label: '永久免费' },
            ].map((stat, idx) => (
              <div
                key={idx}
                className="text-center animate-fade-in-up"
                style={{ animationDelay: `${0.2 + idx * 0.1}s` }}
              >
                <div className="text-2xl md:text-3xl font-black text-white">{stat.num}</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}